/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Remove_PhotoInputs */

const en_admin_resource_form_remove_photo = /** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const de_admin_resource_form_remove_photo = /** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const es_admin_resource_form_remove_photo = /** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const fr_admin_resource_form_remove_photo = /** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

/** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */
const it_admin_resource_form_remove_photo = en_admin_resource_form_remove_photo;

/** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */
const pt_br2_admin_resource_form_remove_photo = en_admin_resource_form_remove_photo;

/** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */
const pl_admin_resource_form_remove_photo = en_admin_resource_form_remove_photo;

/** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */
const hu_admin_resource_form_remove_photo = en_admin_resource_form_remove_photo;

/** @type {(inputs: Admin_Resource_Form_Remove_PhotoInputs) => LocalizedString} */
const ro_admin_resource_form_remove_photo = en_admin_resource_form_remove_photo;

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Admin_Resource_Form_Remove_PhotoInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_remove_photo = /** @type {((inputs?: Admin_Resource_Form_Remove_PhotoInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Remove_PhotoInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_remove_photo(inputs)
	if (locale === "de") return de_admin_resource_form_remove_photo(inputs)
	if (locale === "es") return es_admin_resource_form_remove_photo(inputs)
	if (locale === "fr") return fr_admin_resource_form_remove_photo(inputs)
	if (locale === "it") return it_admin_resource_form_remove_photo(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_remove_photo(inputs)
	if (locale === "pl") return pl_admin_resource_form_remove_photo(inputs)
	if (locale === "hu") return hu_admin_resource_form_remove_photo(inputs)
	return ro_admin_resource_form_remove_photo(inputs)
});
export { admin_resource_form_remove_photo as "admin.resource_form.remove_photo" }